import React from "react";
import MetaTags from "components/meta-tags";

export const Head = ({ location, pageContext: { meta } }) => <MetaTags meta={meta} path={location.pathname} />;
